import { render } from "./CustomerManifestShipmentTable.vue?vue&type=template&id=18c44e92&scoped=true"
import script from "./CustomerManifestShipmentTable.vue?vue&type=script&lang=js"
export * from "./CustomerManifestShipmentTable.vue?vue&type=script&lang=js"

import "./CustomerManifestShipmentTable.vue?vue&type=style&index=0&id=18c44e92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c44e92"]])

export default __exports__